<script>
    import {links, navigate} from "svelte-routing";
    import ListViewItemComponent from "./ListViewItemComponent.svelte";
    import DetailVievItemComponent from "./DetailVievItemComponent.svelte";

    export let config;
    export let mid;
    export let mname;
    export let viewOptions;

    $ : contentItems = loadContentItems(mid);

    function loadContentItems(id) {
        return fetch(config.model_root + 'shared/contents/load_contents_details.php?mid=' + id + "&order=" + viewOptions.sort_by, {
            method: "GET"
        })
            .then(response => response.json());
    }


</script>

{#if viewOptions.view === "list"}
    <article class="px-0 py-2 mb-3 bg-transparent text-center">
        <h2 class="mb-3 site-header">{@html mname}</h2>
    </article>
{/if}

<div use:links>
    {#await contentItems}
        <p class="alert alert-light">
            <i class="fas fa-circle-notch fa-spin me-1"></i> Lade Inhalte...
        </p>
    {:then items}

        {#each items as content}

            {#if content.cvisible == 1}
                {#if viewOptions.view === "list" || (viewOptions.view === "detail" && viewOptions.detail_view_settings === "only_pinned" && content.cpinned == 0)}
                    <ListViewItemComponent {config} {content} showDate={viewOptions.show_date == "SHOW"} showAuthor={viewOptions.show_author == "SHOW"}/>
                {:else if viewOptions.view === "detail"}
                    <DetailVievItemComponent {config} {content}/>
                {/if}
            {/if}

        {/each}

    {:catch error}
        <p style="color: red">{error.message}</p>
    {/await}
</div>

<style>

</style>
